module.exports = __webpack_public_path__ + "img/IntegracionLogERP.232bc1e3.svg";